/**
 * @license
 *-------------------------------------------------------------------------------------------
 * Copyright © 2025 Progress Software Corporation. All rights reserved.
 * Licensed under commercial license. See LICENSE.md in the package root for more information
 *-------------------------------------------------------------------------------------------
 */
import * as e from "react";
import t from "prop-types";
import { classNames as p } from "@progress/kendo-react-common";
const s = e.forwardRef((n, a) => {
  const { children: o, className: c, style: l } = n, r = e.useRef(null);
  e.useImperativeHandle(
    a,
    () => ({
      element: r.current
    })
  );
  const m = p(
    {
      "k-drawer-content": !0
    },
    c
  );
  return /* @__PURE__ */ e.createElement("div", { className: m, style: l, ref: r }, o);
});
s.propTypes = {
  children: t.any,
  className: t.string,
  style: t.object
};
s.displayName = "KendoDrawerContent";
export {
  s as DrawerContent
};
